var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.734 77.364C129.214 75.9447 132.443 75.9383 134.921 77.364C147.384 84.4066 159.852 91.4381 172.313 98.485C174.657 99.8052 176.225 102.414 176.201 105.114V147.485C176.218 150.298 174.496 152.969 172.023 154.259C159.6 161.263 147.184 168.275 134.764 175.279C132.233 176.726 128.938 176.614 126.487 175.049C122.762 172.89 119.032 170.741 115.307 168.585C114.546 168.131 113.688 167.77 113.15 167.032C113.625 166.391 114.475 166.312 115.165 166.032C116.72 165.538 118.148 164.744 119.576 163.974C119.937 163.727 120.378 163.822 120.724 164.043C123.909 165.869 127.065 167.748 130.261 169.556C130.942 169.95 131.633 169.428 132.215 169.103C144.406 162.213 156.611 155.349 168.799 148.457C169.251 148.24 169.501 147.761 169.464 147.266C169.472 133.289 169.466 119.309 169.468 105.332C169.52 104.77 169.195 104.254 168.688 104.025C156.308 97.0529 143.935 90.0705 131.557 83.097C131.343 82.9496 131.089 82.8704 130.829 82.8701C130.569 82.8697 130.314 82.948 130.099 83.0948C117.722 90.0705 105.351 97.0593 92.9736 104.031C92.4678 104.261 92.1284 104.768 92.1886 105.332C92.1907 119.309 92.1886 133.289 92.1886 147.268C92.1671 147.509 92.2201 147.752 92.3405 147.962C92.4609 148.172 92.6428 148.341 92.8617 148.444C96.1647 150.317 99.4719 152.177 102.777 154.044C104.639 155.046 106.925 155.642 108.977 154.874C110.787 154.224 112.056 152.377 112.021 150.455C112.038 136.559 112.013 122.661 112.034 108.768C111.989 108.151 112.574 107.641 113.174 107.699C114.761 107.689 116.35 107.678 117.937 107.704C118.6 107.689 119.055 108.353 118.973 108.974C118.967 122.958 118.991 136.942 118.963 150.926C118.967 154.652 117.436 158.708 113.989 160.531C109.742 162.731 104.493 162.265 100.298 160.155C96.6654 158.342 93.1994 156.203 89.6318 154.261C87.1526 152.978 85.4384 150.296 85.4559 147.486V105.114C85.4299 102.358 87.06 99.7019 89.4768 98.4009C101.897 91.3914 114.316 84.3766 126.734 77.364Z",
    fill: "#8CC84B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.57 106.715C142.987 106.366 148.786 106.508 153.661 109.177C157.435 111.222 159.527 115.514 159.594 119.707C159.488 120.272 158.897 120.584 158.357 120.545C156.786 120.543 155.214 120.567 153.642 120.535C152.975 120.56 152.588 119.946 152.504 119.356C152.052 117.35 150.958 115.363 149.07 114.395C146.171 112.944 142.81 113.017 139.649 113.047C137.342 113.17 134.86 113.37 132.905 114.727C131.405 115.754 130.949 117.829 131.484 119.5C131.989 120.7 133.375 121.087 134.508 121.444C141.036 123.152 147.954 122.982 154.358 125.229C157.009 126.145 159.602 127.926 160.51 130.701C161.697 134.422 161.177 138.869 158.53 141.855C156.383 144.313 153.257 145.651 150.139 146.378C145.991 147.302 141.686 147.326 137.473 146.915C133.512 146.464 129.39 145.423 126.332 142.724C123.717 140.454 122.44 136.916 122.567 133.502C122.597 132.925 123.171 132.523 123.723 132.57C125.306 132.557 126.889 132.553 128.472 132.572C129.104 132.527 129.573 133.073 129.605 133.669C129.897 135.581 130.615 137.587 132.282 138.72C135.499 140.796 139.535 140.653 143.219 140.712C146.27 140.576 149.696 140.535 152.186 138.518C153.5 137.368 153.889 135.443 153.534 133.788C153.149 132.39 151.687 131.738 150.431 131.312C143.986 129.274 136.991 130.013 130.609 127.708C128.018 126.792 125.512 125.061 124.517 122.399C123.128 118.632 123.764 113.972 126.689 111.086C129.54 108.215 133.656 107.11 137.57 106.714V106.715Z",
    fill: "#8CC84B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_1660",
    x: 0.723999,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_1660",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.f065dd8261b59766be7fba601ae99c45.svg";
export { ForwardRef as ReactComponent };